import { devConfig } from "./dev";

export const config = devConfig;
